import script from "./sf-message-outer-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-message-outer-container.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__